import { useEffect, useState } from 'react';

export const useToast = () => {
    const [toastRef, setToastRef] = useState<any | null>();

    const showToast = (config: any) => {
        toastRef?.addToast(config);
    };

    useEffect(() => {
        setToastRef(document.querySelector('.wpp-toast-container'));
    }, []);

    return {
        showToast,
    };
};
